<template>
  <div
    class="d-flex align-center"
    :style="$vuetify.breakpoint.xs && didShowSearchField && `width: 100%`"
  >
    <v-autocomplete
      v-if="didShowSearchField"
      v-model="searchSelected"
      :items="searchItems"
      :search-input.sync="searchKeyword"
      :autofocus="$vuetify.breakpoint.xs"
      dense
      single-line
      hide-details
      hide-no-data
      auto-select-first
      return-object
      clearable
      append-icon=""
      :prepend-inner-icon="$vuetify.breakpoint.smAndUp ? `mdi-magnify` : ``"
      item-text="title"
      :filter="() => true"
      :label="searchLabel"
      :placeholder="searchLabel"
      class="mx-1 fade-in"
      :class="$vuetify.breakpoint.smAndUp && `hidden-xs-only`"
      :style="$vuetify.breakpoint.smAndUp && `width: 240px`"
    >
      <template v-slot:item="{ on, attrs, item }">
        <v-list-item v-on="on" v-bind="attrs" :ripple="false">
          <v-list-item-content>
            <v-list-item-title>
              {{ item.titleTh || item.title }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-caption">
              {{ item.path }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>

    <v-btn
      text
      small
      class="px-0 primary--text hidden-sm-and-up fade-in"
      style="min-width: 28px"
      :ripple="false"
      @click="toggleSearch()"
    >
      <v-icon>{{
        $vuetify.breakpoint.xs && didShowSearchField
          ? "mdi-magnify-close"
          : "mdi-magnify"
      }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { searchProductType } from "@/services/constants";

export default {
  // this component will emit 'value' to 'true' only if search field is showing in 'xs'
  props: ["value"],
  data() {
    return {
      searchKeyword: null,
      searchItems: [],
      searchSelected: null,
      didShowSearchField: false, // if search field is showing this will be 'true'
    };
  },
  mounted() {
    this.didShowSearchField = this.$vuetify.breakpoint.smAndUp;
    setTimeout(() => (this.searchItems = searchProductType()), 1000);
  },
  methods: {
    toggleSearch() {
      this.didShowSearchField = !this.didShowSearchField;
      this.$emit("input", this.didShowSearchField);
    },
  },
  computed: {
    searchLabel() {
      return `${this.$langs.Gen.search[this.$langs.lang]}${
        this.$langs.space[this.$langs.lang]
      }${this.$langs.Product.category[this.$langs.lang]}`;
    },
  },
  watch: {
    searchKeyword(v) {
      this.searchItems = searchProductType(v);
    },
    searchSelected(obj) {
      if (!obj || this.$route.path == obj.path) return;
      this.$router.push(obj.path);
      if (this.$vuetify.breakpoint.xs) setTimeout(() => this.toggleSearch(), 1);
    },
    "$vuetify.breakpoint.smAndUp": async function (wideScreen) {
      if (wideScreen) this.$emit("input", false);
      this.didShowSearchField = wideScreen;
    },
  },
};
</script>

<style>
.small-text-field .v-label {
  font-size: 14px;
}
</style>